import { render, staticRenderFns } from "./AssignViolationModal.vue?vue&type=template&id=451ad810&"
import script from "./AssignViolationModal.vue?vue&type=script&lang=js&"
export * from "./AssignViolationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports